<div [style]="visible ? 'display: block;' : 'display: none;'">
    <mat-progress-bar color="accent" [bufferValue]="bufferValue" [mode]="mode" [value]="value"></mat-progress-bar>
</div>
